import { ContactFormData } from '@/modules/kontakt/components/ContactForm'

export async function sendContactMail(data: ContactFormData) {
  try {
    const response = await fetch('/api/send-mail', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })

    if (!response.ok) {
      return { success: false, error: { message: response.statusText } }
    }
    const responseData = await response.json()
    return { success: true, data: responseData }
  } catch (error) {
    return { success: false, error: { message: error instanceof Error ? error.message : 'Something went wrong' } }
  }
}
